'use strict';

import React from 'react';
import {Link} from 'react-router';
import DocumentTitle from 'react-document-title';
import {performNetworkOperation,getProduceImageLink,performNetworkOperationClientSecure} from "../../utils/Connections.js";
import InvoiceStore from "../../stores/InvoiceStore";

import ViewBills from './ViewBills';
import * as Cookies from '../../utils/Cookies'
import $ from "jquery";
import ActiveOrders from './ActiveOrders';
import * as Connections from "../../utils/Connections";








class Home extends React.Component {
    handleClick;

    constructor(props) {
        super(props);
        this.state={
            suggestedProducts:[],
            frequentProducts:[],
            ongoingOrders:[]

        };
        this.successGetProduce=this.successGetProduce.bind(this);
        this.successGetFrequent=this.successGetFrequent.bind(this);
        this.successGetOngoing=this.successGetOngoing.bind(this);
        this.errorGetProduce=this.errorGetProduce.bind(this);
        this.handleOrder=this.handleOrder.bind(this);
        this.getImageName=this.getImageName.bind(this);
    }


    errorGetProduce(data){
    }


    successGetFrequent(data){

        this.setState({
            frequentProducts:data
        });
    }

    successGetOngoing(data){

        this.setState({
            ongoingOrders:data
        });

    }


    successGetProduce(data){
        let suggestedProducts = $.grep(data,function (item) {
            return item.pickoftheweek == "1";
        });


        this.setState({
            suggestedProducts:suggestedProducts
        })
    }


    componentDidMount(){
        let body={
            method:'POST',
            headers:new Headers({
                'Content-Type':'application/x-www-form-urlencoded'
            }),
            body:$.param({
                type:"get_produce"
            })
        };
        performNetworkOperation(body,this.successGetProduce,this.errorGetProduce)
        body.body=$.param({
            type:"getFrequentProduce",
            token:Cookies.checkCookie("accessToken")
        });

        performNetworkOperationClientSecure(body,this.successGetFrequent,this.errorGetProduce)
        body.body=$.param({
            type:"getOngoingOrders",
            token:Cookies.checkCookie("accessToken")
        });
        performNetworkOperationClientSecure(body,this.successGetOngoing,this.errorGetProduce)


    }
    getImageName(imageName) {
        return Connections.getProduceImageLink() + imageName.replace(" ", "").toLowerCase() + ".jpg";
    }

    handleOrder(product){
        console.log(product)
    }


//FAQ STUFF




    render() {
        return (
            <DocumentTitle title="Khula - Billing">


                <div className="main-content">



                    <div className="home-slider">

                        <div className="slider-image">
                            <img src="https://client.khula.co.za/images/farmerweek3.png"/>
                            <img src="https://client.khula.co.za/images/farmerweek4.png"/>
                            <img src="https://client.khula.co.za/images/farmerweek2.png"/>
                            <img src="https://client.khula.co.za/images/victor.png"/>


                        </div>
                        <div className="slider-content">

                            <h4>FARMER OF THE WEEK</h4>
                            <h5>Victor Masilo</h5>
                            <p>Mooinooi<br/> 165 Ha Citrus, Spinach, Baby Marrow</p>
                        </div>


                    </div>


                    <div className="orders-dashboard">
                        <ActiveOrders/>
                        {/*<h5>Orders in progress</h5>*/}

                        {/*{this.state.ongoingOrders.map((product,i)=>*/}
                        {/*<div>*/}

                        {/*<img style={{height: "60px"}}*/}
                        {/*src={getProduceImageLink()+(product.produce.replace(" ","").toLowerCase())+".jpg"} alt="KHULA"*/}
                        {/*className="img-responsive logo"/>*/}
                        {/*<p><strong>{product.produce}</strong> | {product.quantity} kg's </p>*/}
                        {/*<p>{product.due_date}</p>*/}


                        {/*<button>Track Order</button>*/}
                        {/*</div>*/}
                        {/*)}*/}

                    </div>


                    <div className="suggested-orders">

                        <h5>Weekly Suggestions</h5>

                        {this.state.suggestedProducts.map((product,i)=>
                            <div>

                                <img style={{height: "60px"}}
                                     src={getProduceImageLink()+(product.name.replace(" ","").toLowerCase())+".jpg"} alt="KHULA"
                                     className="img-responsive logo"/>
                                <p><strong>{product.name}</strong> | {product.quantity} kg's </p>
                                <p>R{product.price} per head</p>


                                <button  onClick={() => this.props.self().handleOpenExternal(product.name, product.price, this.getImageName(product.name),"")}>ORDER</button>
                            </div>

                        )
                        }


                    </div>

                    <div className="frequent-orders">



                        <div id="product-cards">
                            <h5>Frequently Ordered</h5>

                            {this.state.frequentProducts.map((product,i)=>
                                <div>

                                    <img style={{height: "60px"}}
                                         src={getProduceImageLink()+(product.name.replace(" ","").toLowerCase())+".jpg"} alt="KHULA"
                                         className="img-responsive logo"/>
                                    <p><strong>{product.name}</strong> | {product.quantity} kg's </p>
                                    <p>R{product.price} per head</p>


                                    <button onClick={() => this.props.self().handleOpenExternal(product.name, product.price, this.getImageName(product.name),"")}>ORDER</button>
                                </div>
                            )}

                        </div>

                        <button id="allbutton">See all products</button>
                    </div>








                    {/*<div className="home-message-container">*/}

                    {/*<img src="https://client.khula.co.za/images/chivas.jpg"/>*/}
                    {/*<h4>KHULA wins Chivas Venture SA</h4>*/}
                    {/*<p>KHULA! recently took part in the Chivas Venture Global competition, hosted in Amsterdam, Nertherlands. Represented by co-founder Matthew Piper,*/}
                    {/*KHULA was placed #1 in South Africa, and was ranked in the top ten social ventures from around the world. The finals saw 20 countries competing at the Next Web conference in Amsterdam*/}
                    {/*in May.</p>*/}


                    {/*</div>*/}


                </div>





            </DocumentTitle>


        );
    }



}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/HopePageBabies/Home.js